/* eslint-disable react/prop-types */
import classNames from "classnames";
import React from "react";
import { useMediaQuery } from "react-responsive";

import { formatPagePath } from "../../../../utils";
import Link from "../../../link";

import * as styles from "./styles.module.scss";

const CondtitonalTertiaryHeader = (props) => {
  const { external, label, item, openTertiary, handleTertiaryClick, onClick } = props;
  const isMobileNavigation = useMediaQuery({ query: "(max-width: 1279px)" });

  if (isMobileNavigation && item.children) {
    // ---------------------------------- | Mobile tertiary nav header
    return (
      <button
        className={classNames(
          `nav_link`,
          styles.nav_link,
          item.children && styles.tertiary_nav_header,
          {
            [styles.is_showing]: openTertiary === label
          }
        )}
        onKeyPress={() => handleTertiaryClick(label)}
        onClick={() => handleTertiaryClick(label)}
      >
        <span>{label}</span>
      </button>
    );
  } else if (external) {
    // ---------------------------------- | Desktop external link, no children
    return (
      <a
        rel="noreferrer noopener"
        href={item.url}
        target="_self"
        className={classNames(
          `nav_link`,
          styles.nav_link,
          item.children && styles.tertiary_nav_header
        )}
        key={item.id}
      >
        {label}
      </a>
    );
  } else {
    // ---------------------------------- | Desktop internal link, no children
    return (
      <Link
        className={classNames(
          `nav_link`,
          styles.nav_link,
          item.children && styles.tertiary_nav_header
        )}
        label={item.linkText || item.link_text}
        newWindow={item.new_window}
        onClick={onClick}
        to={item.page?.data ? formatPagePath(item.page) : item.url}
        key={item.id}
      >
        {label}
      </Link>
    );
  }
};

export default CondtitonalTertiaryHeader;
